import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=019baf18&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=ts"
export * from "./_slug.vue?vue&type=script&lang=ts"
import style0 from "./_slug.vue?vue&type=style&index=0&id=019baf18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019baf18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeading: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-heading.vue').default,CBtn: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/content/c-btn.vue').default,ProjectMember: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/project-member.vue').default,ViewMore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/view-more.vue').default,PageShare: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-share.vue').default,ListControl: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/list-control.vue').default})
